import LMSDispatcher from "../../LMSDispatcher";
import { EventEmitter } from "events";


import * as ACTIONCONSTANTS from "../../actions/ActionConstants";
import { IDateTimeFormatData } from "../../../models/sample/DateTimeFormatData";

interface IDateTimeList {
    state: {
        dateTimeFormat?: IDateTimeFormatData
    }
}

class DateTimeStore extends EventEmitter implements IDateTimeList {

    state: {
        dateTimeFormat?: IDateTimeFormatData | undefined;
    };

    constructor() {
        super();

        this.state = {
            dateTimeFormat: {
                cultureCode: "",
                dateFormat: "",
                timeFormat: "",
                fullTimeFormat: "",
                timeOffset: ""
              }
        }

        LMSDispatcher.register((e: any) => {
            switch (e.type) {
                case ACTIONCONSTANTS.SAMPLE_GET_DATE_FORMAT:
                    Object.assign(this.state, e.payload);
                    this.emit('change', this.state);
                    break;
            }
        });
    }
}

const dateTimeStore = new DateTimeStore();

export default dateTimeStore;